export const plansArray = [
  {
    title: 'Free 30-day Trial',
    subtitle:
      'Build a working prototype of your integration for free, then decide if you want to subscribe.',
  },
  {
    title: 'Flat Subscription Fee',
    subtitle:
      'Fixed monthly subscrpition fee that depends on the size of your team, features you need, and the level of support. Starts at $500/mo.',
    icon: 'pricing-plan--1',
  },
  {
    title: 'Predictable usage-based pricing that fits your business model',
    subtitle:
      'Depending on how your product and business works, we offer per-customer, per-integration, per-connection, and other pricing options.',
    icon: 'pricing-plan--2',
  },
]
